"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Dashboard_vue_1 = __importDefault(require("../../pages/dashboard/Dashboard.vue"));
exports.default = [
    {
        name: 'home',
        path: '/',
        component: Dashboard_vue_1.default,
        meta: { requiresAuth: true, title: 'Dashboard' }
    },
    {
        name: 'api_sales_contacts',
        path: '/api/sales-contacts',
        redirect: '',
        meta: { requiresAuth: true }
    },
];
